import { DialogTitle } from "@radix-ui/react-dialog";
import { DialogHeader } from "../../../../../components/ui/dialog";

interface HeaderProps {
  title: string;
}
export default function Header({ title }: HeaderProps) {
  return (
    <DialogHeader className="border-b border-gray01 pb-8 max-sm:pb-4">
      <DialogTitle className="text-xl font-semibold text-black01 max-sm:text-lg">
        {title}
      </DialogTitle>
    </DialogHeader>
  );
}
